module.exports = __webpack_public_path__ + "static/img/1.89dcf39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/1.jpg
// module id = aKyS
// module chunks = 0